import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { RegisterModule } from 'src/app/common-components/register/register.module';

import { AllowedIpRegisterComponent } from './containers/allowed-ip-register.component';
import { AllowedIpRegisterEffects } from './state/allowed-ip-register.effects';
import { allowedIpRegisterFeatureKey, allowedIpRegisterReducer } from './state/allowed-ip-register.reducer';
import { AllowedIpRegisterViewComponent } from './views/allowed-ip-register-view.component';

@NgModule({
   declarations: [AllowedIpRegisterComponent, AllowedIpRegisterViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      MatMenuModule,
      RegisterModule,
      ScrollingModule,

      EffectsModule.forFeature([AllowedIpRegisterEffects]),
      StoreModule.forFeature(allowedIpRegisterFeatureKey, allowedIpRegisterReducer),
   ],
})
export class AllowedIpRegisterModule {}
